"use client"

import { useLocation } from 'react-router-dom';
import SideBar from './sidebar/index'

export default function Sidebar() {
  const { pathname } = useLocation();
  if (pathname === '/on-boarding/survey/') return null;
  return <SideBar />
}
